module.exports = __webpack_public_path__ + "img/avalon_logo.37b79d2f.png";